import React, { useState } from 'react'
import Lightbox from 'react-images'
import {
  Div, P,
} from 'konsys-ui'
import Container from '../../components/container'
import {
  BgContainer, WidthContainer, Title, SampleDiv, SampleImg,
} from './styled'
import { theme } from '../../styles/_variables'
import Banner from '../../images/printing-information/banner.jpg'
import pump1 from '../../images/printing-information/Printing-Techniques/1-1_Embossing.jpg'
import pump31 from '../../images/printing-information/Printing-Techniques/1-3_Foiling_01.jpg'
import pump32 from '../../images/printing-information/Printing-Techniques/1-3_Foiling_02.jpg'
import pump33 from '../../images/printing-information/Printing-Techniques/1-3_Foiling_03.jpg'
import coat11 from '../../images/printing-information/Printing-Techniques/2-1-1_Vanish_Glossy.jpg'
import coat2 from '../../images/printing-information/Printing-Techniques/2-2_UV_Coating.jpg'
import coat311 from '../../images/printing-information/Printing-Techniques/2-3-1_OPP_Glossy_01.jpg'
import coat312 from '../../images/printing-information/Printing-Techniques/2-3-1_OPP_Glossy_02.jpg'
import coat321 from '../../images/printing-information/Printing-Techniques/2-3-2_OPP_Matt_01.jpg'
import coat322 from '../../images/printing-information/Printing-Techniques/2-3-2_OPP_Matt_02.jpg'
import coat331 from '../../images/printing-information/Printing-Techniques/2-3-3_OPP_Rainbow_01.jpg'
import coat332 from '../../images/printing-information/Printing-Techniques/2-3-3_OPP_Rainbow_02.jpg'
import coat333 from '../../images/printing-information/Printing-Techniques/2-3-3_OPP_Rainbow_03.jpg'
import coat411 from '../../images/printing-information/Printing-Techniques/2-4-1_Spot_UV_Glossy_01.jpg'
import coat412 from '../../images/printing-information/Printing-Techniques/2-4-1_Spot_UV_Glossy_02.jpg'
import coat413 from '../../images/printing-information/Printing-Techniques/2-4-1_Spot_UV_Glossy_03.jpg'
import coat42 from '../../images/printing-information/Printing-Techniques/2-4-2_Spot_UV_Matt_01.jpg'
import coat431 from '../../images/printing-information/Printing-Techniques/2-4-3_Spot_UV_Special_01.jpg'
import coat432 from '../../images/printing-information/Printing-Techniques/2-4-3_Spot_UV_Special_02.jpg'
import coat433 from '../../images/printing-information/Printing-Techniques/2-4-3_Spot_UV_Special_03.jpg'
import coat434 from '../../images/printing-information/Printing-Techniques/2-4-3_Spot_UV_Special_04.jpg'
import place1 from '../../images/printing-information/Printing-Techniques/3-1_Plastic_Windows.jpg'
import place21 from '../../images/printing-information/Printing-Techniques/3-2_Side_Attached_01.jpg'
import place22 from '../../images/printing-information/Printing-Techniques/3-2_Side_Attached_02.jpg'
import place23 from '../../images/printing-information/Printing-Techniques/3-2_Side_Attached_03.jpg'
import dicut1 from '../../images/printing-information/Printing-Techniques/4_Dicut_01.jpg'
import dicut2 from '../../images/printing-information/Printing-Techniques/4_Dicut_02.jpg'
import { ContentInfo } from '.'

const allImage = [pump1, pump31, pump32, pump33, coat11,
  coat2, coat311, coat312, coat321, coat322, coat331, coat332,
  coat333, coat411, coat412, coat413, coat42, coat431, coat432,
  coat433, coat434, place1, place21, place22, place23, dicut1, dicut2]

const PrintingTechnique = () => {
  const [openLightBox, setOpenLightBox] = useState(false)
  const [currentImage, setCurrentImage] = useState(0)

  return (
    <Container
      header={{
        type: 'title',
        img: Banner,
        title: 'เทคนิคงานพิมพ์',
      }}
    >
      <Div>
        <BgContainer>
          <WidthContainer>
            <ContentInfo
              title='เทคนิคงานพิมพ์'
              content='คือ เทคนิคพิเศษที่ใช้สำหรับงานพิมพ์เพื่อเพิ่มความโดดเด่น หรือสร้างความสวยงามของชิ้นงาน เรามีเทคนิคงานพิมพ์มากมายที่คุณสามารถเลือกใช้ในการสร้างสรรค์ชิ้นงานของคุณ'
            />
            <Div margin='0 0 18px'>
              <Title superGreen>เทคนิคการปั๊ม</Title>
            </Div>
            <ContentInfo
              title='1. ปั๊มนูน (Embossing)'
              content={`คือ การใช้แม่พิมพ์กดทับกระดาษให้นูนขึ้นเพื่อสร้างความนูนตามแบบของแม่พิมพ์ที่ใช้กดทับ
               ซึ่งสามารถเพิ่มมิติบนพื้นผิวของบรรจุภัณฑ์ นิยมใช้สร้างความโดดเด่นในส่วนของตราสินค้า หรือข้อความที่ต้องการเน้นความสำคัญ`}
              sample={[
                { image: 0, src: pump1 },
              ]}
              openLightBox={(image) => {
                setOpenLightBox(true)
                setCurrentImage(image)
              }}
            />
            <ContentInfo
              title='2. ปั๊มจม (Debossing)'
              content='คือ การใช้แม่พิมพ์กดทับกระดาษให้มีความลึกเพื่อสร้างความลึกตามแบบของแม่พิมพ์ที่ใช้กดทับ นิยมใช้สร้างลวดลายเพิ่มความสวยงาม  หรือเพิ่มมิติบนพื้นผิวของบรรจุภัณฑ์'
            />
            <ContentInfo
              title='3. ปั๊มทองเค (Foiling)'
              content={`คือ การใช้แท่นความร้อนที่ถูกประกบด้วยฟอยล์ทองสีต่างๆที่จะถูกละลายด้วยความร้อน เมื่อประทับหรือปั๊มลงบนกระดาษ
               ฟอยล์ทองจะเคลือบติดลงบนกระดาษ ฟอยล์ที่เคลือบลงบนกระดาษจะมีความมันเงา สะท้อนแสง สามารถเพิ่มความโดดเด่น
               และมูลค่าของชิ้นงาน นิยมใช้กับสัญลักษณ์ทางการค้า ขอบหรือลวดลายเส้นบนกล่องบรรจุภัณฑ์
               สามารถเลือกสีฟอยล์ที่เหมาะสมกับชิ้นงานของคุณได้ ได้แก่ สีทอง สีเงิน สีน้ำเงิน สีเขียว สีแดง และอื่นๆ`}
              sample={[
                { image: 1, src: pump31 },
                { image: 2, src: pump32 },
                { image: 3, src: pump33 },
              ]}
              openLightBox={(image) => {
                setOpenLightBox(true)
                setCurrentImage(image)
              }}
            />
            <Div margin='0 0 18px'>
              <Title superGreen>เทคนิคการเคลือบ</Title>
            </Div>
            <ContentInfo
              title='1. การเคลือบวานิช'
              content={`คือ การเคลือบผิวกระดาษด้วยน้ำมันวานิช กระดาษที่ถูกเคลือบด้วยน้ำมันวานิชจะยังคงสามารถถูกฉีกขาดและเปื่อยยุ่ยได้เมื่อเปียกน้ำ
               จึงนิยมใช้เพื่อเคลือบผิวกระดาษป้องกันการเสียดสีและความชื้นเล็กน้อย การเคลือบวานิชสามารถแบ่งออกเป็น 2 ประเภท ได้แก่  การเคลือบวานิชเงา และการเคลือบวานิชด้าน`}
              subContent={[
                {
                  title: '1.1 การเคลือบวานิชเงา (Glossy Coating)',
                  content: `เป็นการเคลือบผิวกระดาษด้วยน้ำมันวานิชที่เพิ่มการสะท้อนแสงบนชิ้นงานมากขึ้น
                   จึงเกิดความเงาบนผิวกระดาษ แต่อย่างไรก็ตามการเคลือบวานิชเงาจะสร้างความเงาที่ไม่สูงมากนัก จึงถูกจัดเป็นการเคลือบที่ให้ความเงาในระดับต่ำ`,
                  sample: [
                    { image: 4, src: coat11 },
                  ],
                }, {
                  title: '1.2 การเคลือบวานิชด้าน (Matt Coating)',
                  content: 'เป็นการเคลือบผิวกระดาษด้วยน้ำมันวานิชที่ลดการสะท้อนแสงบนชิ้นงาน จึงทำให้เกิดความเงาบนผิวกระดาษลดลง การเคลือบวานิชด้านจะทำให้ผิวกระดาษมีลักษณะด้านมากขึ้นเล็กน้อย',
                },
              ]}
              openLightBox={(image) => {
                setOpenLightBox(true)
                setCurrentImage(image)
              }}
            />
            <ContentInfo
              title='2. การเคลือบยูวี (UV Coating)'
              content={`คือ การเคลือบผิวกระดาษด้วยน้ำยาเคลือบเงาชนิดที่สามารถแห้งได้เมื่อผ่านแสงยูวี
               ซึ่งจะให้ความเงาบนชิ้นงานสูงกว่าการเคลือบวานิช เราใช้การเคลือบยูวีประเภทมีตัวทำละลายด้วยน้ำ (Water Based UV) ซึ่งมีความเป็นมิตรต่อสิ่งแวดล้อม`}
              sample={[
                { image: 5, src: coat2 },
              ]}
              openLightBox={(image) => {
                setOpenLightBox(true)
                setCurrentImage(image)
              }}
            />
            <ContentInfo
              title='3. การเคลือบพลาสติก (OPP Film Laminating)'
              content={`คือ การเคลือบผิวกระดาษด้วยแผ่นฟิล์มพลาสติกประเภทโอพีพี ทำให้กระดาษมีความเหนียวฉีกไม่ขาดและสามารถกันน้ำได้
               จุดเด่นของการเคลือบพลาสติกคือความเรียบและความเงาของชิ้นงานที่สูงกว่าการเคลือบยูวี จึงเหมาะกับงานที่ต้องการความทนทานและความเงามากขึ้น แต่มีต้นทุนในการผลิตที่สูงกว่า`}
              openLightBox={(image) => {
                setOpenLightBox(true)
                setCurrentImage(image)
              }}
              subContent={[
                {
                  title: '3.1 การเคลือบพลาสติกแบบเงา (Glossy OPP Film Laminating)',
                  content: 'เป็นการเคลือบพลาสติกโดยการใช้ฟิล์มที่มีผิวมันวาวสร้างความเรียบของพื้นผิวและเพิ่มความเงาในระดับสูง',
                  sample: [
                    { image: 6, src: coat311 },
                    { image: 7, src: coat312 },
                  ],
                }, {
                  title: '3.2 การเคลือบพลาสติกแบบด้าน (Matt OPP Film Laminating)',
                  content: `เป็นการเคลือบพลาสติกโดยการใช้ฟิล์มที่มีผิวด้านหน้ามีความขุ่นและด้าน แสงส่องผ่านได้ยาก
                   ใช้ในการสร้างชิ้นงานที่ต้องการลดความเงาของผิวกระดาษ นิยมใช้เพื่อเพิ่มมิติพื้นผิวสัมผัสของชิ้นงาน`,
                  sample: [
                    { image: 8, src: coat321 },
                    { image: 9, src: coat322 },
                  ],
                }, {
                  title: '3.3 การเคลือบพลาสติกแบบรุ้ง (Rainbow OPP Film Laminating)',
                  content: 'เป็นการเคลือบพลาสติกแบบเงาแต่ฟิล์มที่ใช้มีสีสันสดใสสะท้อนแสงเป็นสีต่างๆ มีให้เลือกหลากหลายรูปแบบตามความเหมาะสมกับชิ้นงานของคุณ',
                  sample: [
                    { image: 10, src: coat331 },
                    { image: 11, src: coat332 },
                    { image: 12, src: coat333 },
                  ],
                },
              ]}
            />
            <ContentInfo
              title='4. การเคลือบยูวีเฉพาะจุด (Spot UV Coating)'
              content={`คือ การเคลือบยูวีเพื่อสร้างความเงาเฉพาะบริเวณที่ต้องการ อาทิ ตัวอักษร สัญลักษณ์ ลวดลาย
               หรือส่วนที่ต้องการเน้นความสำคัญ สามารถผสมผสานการเคลือบยูวีเฉพาะจุดกับการเคลือบและเทคนิคงานพิมพ์ชนิดอื่นๆได้
               นิยมใช้การเคลือบยูวีเฉพาะจุดควบคู่กับการปั๊มนูนลงบนสัญลักษณ์หรือข้อความ ร่วมกับการเคลือบพลาสติกแบบด้านบริเวณผิวพื้นอื่น
               เพื่อสร้างความแตกต่างระหว่างสองพื้นผิวให้มีความชัดเจนมากยิ่งขึ้น`}
              openLightBox={(image) => {
                setOpenLightBox(true)
                setCurrentImage(image)
              }}
              subContent={[
                {
                  title: '4.1  การเคลือบยูวีเฉพาะจุดแบบเงา (Glossy Spot UV Coating)',
                  content: 'เป็นการเคลือบยูวีเฉพาะจุดเพื่อสร้างความเงาลงบนส่วนที่ต้องการ',
                  sample: [
                    { image: 13, src: coat411 },
                    { image: 14, src: coat412 },
                    { image: 15, src: coat413 },
                  ],
                }, {
                  title: '4.2  การเคลือบยูวีเฉพาะจุดแบบด้าน (Matt Spot UV Coating)',
                  content: 'เป็นการเคลือบยูวีเฉพาะจุดเพื่อลดความเงาลงบนส่วนที่ต้องการ',
                  sample: [
                    { image: 16, src: coat42 },
                  ],
                }, {
                  title: '4.3 การเคลือบยูวีเฉพาะจุดแบบพิเศษ (Special Spot UV Coating)',
                  content: `เป็นการเคลือบยูวีเฉพาะจุดที่ถูกปรับปรุงโดยการผสมสารหรือวัสดุอื่นๆร่วมด้วย เพื่อสร้างลวดลายพื้นผิว
                   เพิ่มความแปลกใหม่ให้กับชิ้นงาน อาทิ การเคลือบยูวีเฉพาะจุดแบบทราย
                   ซึ่งเป็นการผสมผงทรายลงไปในสารเคลือบเพื่อสร้างพื้นผิวแบบเม็ดทราย,  การเคลือบยูวีเฉพาะจุดแบบกากเพชร
                   ซึ่งเป็นการผสมผงกากเพชรลงไปในสารเคลือบเพื่อสร้างพื้นผิวสะท้อนแสงแบบกากเพชร, และการเคลือบยูวีเฉพาะจุดแบบเหลือบมุก
                   ซึ่งเป็นการผสมผงเหลือบมุกลงไปในสารเคลือบเพื่อสร้างพื้นผิวแบบเหลือบมุก`,
                  sample: [
                    { image: 17, src: coat431 },
                    { image: 18, src: coat432 },
                    { image: 19, src: coat433 },
                    { image: 20, src: coat434 },
                  ],
                },
              ]}
            />
            <Div display='flex' flexDirection='column' margin='0 0 18px'>
              <Div margin='0 0 16px'>
                <Title superGreen>เทคนิคการปะ</Title>
              </Div>
              <P color={theme.color.lightGrey}>คือ การปะประกบชิ้นงานเพื่อขึ้นรูปกล่องบรรจุภัณฑ์ก่อนดำเนินการจัดส่ง สามารถแบ่งออกได้เป็น 3 ประเภท</P>
            </Div>
            <ContentInfo
              title='1. การปะหน้าต่างพลาสติก'
              content='คือ การติดแผ่นพลาสติกใสลงบนพื้นที่ที่มีการเจาะรูเพื่อแสดงลักษณะสินค้าด้านในกล่องบรรจุภัณฑ์'
              sample={[
                { image: 21, src: place1 },
              ]}
              openLightBox={(image) => {
                setOpenLightBox(true)
                setCurrentImage(image)
              }}
            />
            <ContentInfo
              title='2. การปะข้าง'
              content={`คือ การติดกาวเพื่อเชื่อมติดด้านข้างของกล่องบรรจุภัณฑ์ เพื่อทำให้กระดาษมีลักษณะโอบล้อมในรูปแบบของกล่อง
               นิยมใช้การปะข้างเป็นรูปแบบในการจัดส่ง เนื่องจากกล่องยังไม่ถูกขึ้นรูปสมบูรณ์
               แต่สามารถถูกพับให้แบนราบเพื่อประหยัดพื้นที่และสะดวกในการจัดส่ง ทั้งยังสามารถนำมาขึ้นรูปกล่องได้ง่ายขณะใช้งานจริง`}
              sample={[
                { image: 22, src: place21 },
                { image: 23, src: place22 },
                { image: 24, src: place23 },
              ]}
              openLightBox={(image) => {
                setOpenLightBox(true)
                setCurrentImage(image)
              }}
            />
            <ContentInfo
              title='3. การปะขึ้นรูปกล่อง'
              content='คือ การประกบชิ้นงานเพื่อขึ้นรูปกล่องที่สมบูรณ์ พร้อมใช้งาน'
            />
            <Div display='flex' flexDirection='column' margin='0 0 18px'>
              <Div margin='0 0 16px'>
                <Title superGreen>เทคนิคการเจาะ หรือการไดคัท</Title>
              </Div>
              <P color={theme.color.lightGrey}>{`คือ การสร้างช่องโหว่ลงบนชิ้นงานของคุณสำหรับจุดประสงค์ต่างๆ อาทิ การเจาะเพื่อใช้ในการพกพา,
               การเจาะเพื่อใช้สำหรับการระบายอากาศ, หรือการเจาะเพื่อนำไปปะหน้าต่างพลาสติกสำหรับการแสดงสินค้าด้านใน`}</P>
              <SampleDiv>
                <SampleImg onClick={() => {
                  setOpenLightBox(true)
                  setCurrentImage(25)
                }} src={dicut1}/>
                <SampleImg onClick={() => {
                  setOpenLightBox(true)
                  setCurrentImage(26)
                }} src={dicut2}/>
              </SampleDiv>
            </Div>
          </WidthContainer>
        </BgContainer>
        <Lightbox
          images={allImage.map(v => (
            { src: v }
          ))}
          currentImage={currentImage}
          isOpen={openLightBox}
          onClickNext={() => setCurrentImage(currentImage + 1)}
          onClickPrev={() => setCurrentImage(currentImage - 1)}
          onClose={() => setOpenLightBox(false)}
          backdropClosesModal={true}
        />
      </Div>
    </Container>
  )
}

export default PrintingTechnique



// WEBPACK FOOTER //
// ./src/pages/printing-information/printing-technique.jsx